// Se muestra cuando hay una sesión válida pero el rol no es super_admin
// (ver guardas.js). Caso esperado, por ejemplo, si un admin_empresa abre
// por error la URL del Panel Super Admin en vez de la del Panel Cliente.

import { cerrarSesion } from '../estado-sesion.js';

export function vistaSinPermiso(contenedor) {
  contenedor.innerHTML = `
    <div class="pf-login">
      <div class="pf-tarjeta pf-login__tarjeta" style="text-align: center;">
        <h1 class="pf-login__titulo">Sin acceso</h1>
        <p class="pf-texto-suave">
          Tu cuenta no tiene permisos de administrador de la plataforma.
          Si crees que esto es un error, contacta a soporte.
        </p>
        <button type="button" class="pf-boton pf-boton--secundario" id="pf-btn-salir-sin-permiso">
          Cerrar sesión
        </button>
      </div>
    </div>
  `;

  contenedor.querySelector('#pf-btn-salir-sin-permiso').addEventListener('click', async () => {
    await cerrarSesion();
  });
}
